<template>
  <div>
    <div style="text-align: center" v-if="list.length == 0 && !loading">
      <div
        style="
          display: inline-block;
          width: 213px;
          text-align: center;
          margin-top: 210px;
          margin-bottom: 20px;
          line-height: 200px;
        "
      >
        <img style="width: 100%" :src="require('@/assets/images/moments/empty_photo.png')" />
      </div>
      <p style="font-size: 22px; color: #5f6368; font-family: Roboto">
        {{ emptyWords }}
      </p>
    </div>
    <div
      class="image-list clearfix"
      :class="{ 'check-mode': checkedList.length > 0 }"
      v-loading="loading"
      v-else
    >
      <!-- <el-row :gutter="10">
      <el-col :lg="4" :sm="6"  v-for="(item, index) in list" :key="index"> -->
      <div class="item" v-for="(item, index) in list" :key="index">
        <div
          v-if="item.createTime && showDate"
          class="time"
          :class="{ first: isfirstDate(index) }"
          @mouseenter="handleMouseEnter(item)"
          @click="checkDate(item)"
        >
          <span
            class="check-date"
            :class="{ checked: ifCheckedDate(item) }"
            v-if="showDateCheck(item)"
          >
            <i class="el-icon-check"></i>
          </span>
          <span>{{ generateTimeStr(item.createTime) }}</span>
        </div>
        <div v-else class="time"></div>
        <div
          class="img-box"
          :class="{ checkdisabled: !canCheck }"
          @mouseenter="handleMouseEnter(item)"
          @mouseleave="handleMouseLeave(item)"
        >
          <span
            class="check-btn"
            v-if="canCheck"
            :class="{
              checked: checkedList.findIndex((o) => o.id == item.id) >= 0
            }"
            @click="check(item)"
          >
            <i class="el-icon-check"></i>
          </span>
          <span class="pending" v-if="item.shareStatus == 1"><i class="el-icon-more"></i></span>
          <span class="shared" v-if="item.shareStatus == 2"><i class="el-icon-check"></i></span>
          <!-- <base-img
              class="img"
              fit="fill"
              v-if="item.path"
              :src="rootPath+item.path"
              @click.self="itemClick(item)"
            ></base-img> -->
          <span
            class="img"
            v-if="item.path && item.path.includes('?')"
            v-lazy:background-image="thumbImage(item)"
            @click.self="itemClick(item, true)"
          >
            <i class="iconfont iconplay2" v-if="item.mediaType === 1"></i>
            <i
              class="el-icon-star-on fav"
              v-if="
                (item.favourite == 1 && !item.shareList) ||
                (item.favourite == 1 && item.shareList.length === 1)
              "
            ></i>
            <span class="count" v-if="item.count > 1">{{ item.count }}</span>
          </span>
          <span
            class="img"
            v-else-if="item.path"
            v-lazy:background-image="thumbImage(item)"
            @click.self="itemClick(item, true)"
          >
            <i class="iconfont iconplay2" v-if="item.mediaType === 1"></i>
            <i
              class="el-icon-star-on fav"
              v-if="
                (item.favourite == 1 && !item.shareList) ||
                (item.favourite == 1 && item.shareList.length === 1)
              "
            ></i>
            <span class="count" v-if="item.count > 1">{{ item.count }}</span>
          </span>
        </div>
      </div>
      <!-- </el-col>
    </el-row> -->
    </div>
    <imgDetail
      @updateImg="updateImg"
      ref="imgDetail"
      :readOnly="readOnly"
      @onSwitch="itemClick"
      :classId="classId"
      @detailClose="$emit('refresh')"
    />
    <imgDetailTrash ref="imgDetailTrash" @onSwitch="itemClick" :classId="classId" />
  </div>
</template>

<script>
import moment from 'moment'

import { Ajax } from '@/common'
import { ossThumbUrl } from '@/common/ossImage'
import imgDetail from './detail/index'
import imgDetailTrash from './detailtrash/index'
export default {
  components: { imgDetail, imgDetailTrash },
  props: {
    readOnly: {
      default: false,
      type: Boolean
    },
    classId: {
      default: '',
      type: String
    },
    list: {
      default: () => [],
      type: Array
    },
    canCheck: {
      default: true,
      type: Boolean
    },
    showDate: {
      default: true,
      type: Boolean
    },
    // pending:{
    //   default: false,
    //   type: Boolean
    // },
    loading: {
      default: false,
      type: Boolean
    },
    singleSelect: {
      default: false,
      type: Boolean
    },
    type: {
      default: '',
      type: String
    },
    emptyWords: {
      default: 'No photo yet.',
      type: String
    }
  },
  data() {
    return {
      checkedList: [],
      rootPath: process.env.VUE_APP_fileBasePath,
      hoverDate: '',
      checkedDates: []
    }
  },
  mounted() {},
  watch: {
    checkedList() {
      this.$emit('checkChange', this.checkedList)
    }
  },
  methods: {
    moment,
    // 列表网格 208x144 显示框：按框等比缩小（DPR 上限 2），详情大图仍走 itemClick 原图
    thumbImage(item) {
      const path = item && item.mediaType === 1 ? item.imagePath : item && item.path
      return path ? ossThumbUrl(this.rootPath + path, 208, 144) : ''
    },
    ifCheckedDate(item) {
      let date = moment.utc(item.createTime).local().format('DD/MM/YYYY')
      console.log('ifCheckedDate', !!this.checkedDates.find((c) => c === date))
      return !!this.checkedDates.find((c) => c === date)
    },
    updateImg(src, index) {
      console.log(555555555555)
      console.log(src)
      console.log(index)
      if (index > -1) {
        console.log(444)
        this.list[index].path = src
      }
    },
    showDateCheck(item) {
      let date = moment.utc(item.createTime).local().format('DD/MM/YYYY')
      return this.hoverDate && this.hoverDate === date
    },
    handleMouseEnter(item) {
      console.log('handleMouseEnter', item)
      this.hoverDate = moment.utc(item.createTime).local().format('DD/MM/YYYY')
    },
    handleMouseLeave(item) {
      5
      console.log('handleMouseLeave')
      this.hoverDate = ''
    },
    generateTimeStr(timeStr) {
      return moment.utc(timeStr).local().format('DD/MM/YYYY')
    },
    isfirstDate(index) {
      if (index == 0) {
        return true
      }
      if (
        moment.utc(this.list[index].createTime).local().format('DD/MM/YYYY') !=
        moment
          .utc(this.list[index - 1].createTime)
          .local()
          .format('DD/MM/YYYY')
      ) {
        return true
      }
      return false
    },
    checkDate(item) {
      let date = moment.utc(item.createTime).local().format('DD/MM/YYYY')
      if (this.checkedDates.find((c) => c === date)) {
        this.checkedDates = this.checkedDates.filter((c) => c !== date)
        this.checkedList = this.checkedList.filter((e) => {
          let itemDate = moment.utc(e.createTime).local().format('DD/MM/YYYY')
          return itemDate !== date
        })
      } else {
        this.checkedDates.push(date)
        this.list.forEach((e) => {
          let itemDate = moment.utc(e.createTime).local().format('DD/MM/YYYY')
          if (itemDate === date && !this.checkedList.find((o) => o.id === e.id)) {
            this.checkedList.push(e)
          }
        })
      }
    },
    check(item) {
      if (this.singleSelect) {
        // 单选模式
        this.checkedList = [item]
      } else {
        // 多选模式
        const _i = this.checkedList.findIndex((o) => o.id === item.id)
        if (_i < 0) {
          this.checkedList.push(item)
        } else {
          this.checkedList.splice(_i, 1)
          this.checkedDates = this.checkedDates.filter(
            (c) => c !== moment.utc(item.createTime).local().format('DD/MM/YYYY')
          )
        }
      }
    },
    clearCheck() {
      this.checkedList = []
      this.checkedDates = []
    },
    async itemClick(item, click, ls, isInBatch) {
      console.log('itemClick', item, ls, isInBatch)
      this.$refs.imgDetail.handleBack()
      this.$refs.imgDetailTrash.handleBack()
      // this.$router.push({name:'momentsDetail',params:{id:item.id}})
      var _comp = this.$refs.imgDetail

      if (item.deleted == 1 || this.type == 'trash') {
        _comp = this.$refs.imgDetailTrash
      } else {
        _comp = this.$refs.imgDetail
      }
      if (item.count > 1 && click) {
        var res = await Ajax.get('/moments/share/getListByBatchNo', {
          batchNo: item.batchNo
        })

        if (res.code == '0000') {
          _comp.show(item, res.data, true)
        }
      } else if (ls && isInBatch) {
        _comp.show(item, ls, isInBatch)
      } else {
        _comp.show(item, this.list)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.image-list {
  width: 100%;
  padding-bottom: 30px;
  min-height: 70vh;

  /deep/ .el-loading-mask {
    background-color: transparent;
  }

  .time {
    display: flex;
    align-items: center;

    .check-date {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background: rgb(95, 99, 104);
      // border:2px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;

      .el-icon-check {
        color: #fff;
        // width: 20px;
        // height: 20px;
        font-size: 18px;
        // line-height: 20px;
        text-align: center;
        font-weight: bold;
      }

      &.checked {
        background: #1a73e8;
        border-color: #1a73e8;

        .el-icon-check {
          display: block;
          color: #fff;
        }
      }
    }
  }

  &.check-mode {
    .img-box {
      .check-btn {
        opacity: 1;
      }
    }
  }

  .item {
    // padding:10px 10px 0;

    float: left;
    margin-right: 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0;
    line-height: 0;
  }

  .time {
    line-height: 30px;
    padding-top: 8px;
    font-size: 14px;
    color: #777;
    font-family: Arial, Helvetica, sans-serif;
    opacity: 0;

    &.first {
      opacity: 1;
    }
  }

  .img-box {
    width: 100%;
    position: relative;

    .img {
      display: block;
      width: 208px;
      height: 144px;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      position: relative;
      background-color: #e0e0e0;
      border-radius: 4px;

      &:before {
        content: ' ';
        position: absolute;
        height: 30px;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 2;
        opacity: 0;
        border-radius: 4px 4px 0 0;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
      }
      .iconplay2 {
        position: absolute;
        font-size: 32px;
        color: #fff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
      }
    }

    &.checkdisabled {
      .img:before {
        display: none;
      }
    }

    .fav {
      position: absolute;
      color: #fff;
      left: 6px;
      bottom: 6px;
      font-size: 18px;
    }

    .count {
      position: absolute;
      color: #fff;
      right: 6px;
      bottom: 6px;
      font-size: 14px;
      width: 20px;
      height: 20px;
      line-height: 18px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 2px;

      &:after {
        content: ' ';
        position: absolute;
        left: -4px;
        bottom: -4px;
        font-size: 14px;
        width: 20px;
        height: 20px;
        border: 1px solid #fff;
        border-width: 0 0 1px 1px;
        border-radius: 2px;
      }
    }

    .check-btn {
      width: 24px;
      height: 24px;
      position: absolute;
      z-index: 3;
      left: 7px;
      top: 7px;
      border-radius: 100%;
      background: transparent;
      border: 2px solid #fff;
      opacity: 0;

      .el-icon-check {
        color: #999;
        width: 20px;
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        display: none;
      }

      &.checked {
        background: #1a73e8;
        border-color: #1a73e8;

        .el-icon-check {
          display: block;
          color: #fff;
        }
      }
    }

    .pending {
      background: #e5493d;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      line-height: 24px;
      text-align: center;
      position: absolute;
      z-index: 3;
      right: 8px;
      top: 8px;
      color: #fff;

      .el-icon-more {
        font-size: 16px;
        vertical-align: middle;
        margin-top: -2px;
      }
    }

    .shared {
      background: #3db175;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      line-height: 24px;
      text-align: center;
      position: absolute;
      z-index: 3;
      right: 8px;
      top: 8px;
      color: #fff;

      .el-icon-check {
        font-size: 16px;
        vertical-align: middle;
        margin-top: -2px;
      }
    }

    &:hover {
      .img:before {
        opacity: 1;
      }

      .check-btn:not(.checked) {
        opacity: 0.5;
        background: #fff;

        .el-icon-check {
          display: block;
        }

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>
